import { Component, ElementRef, Input } from '@angular/core';

@Component({
  selector: 'hbo-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent {
  private tooltipInstance: any = null;
  iconColor = '#6c757d';

  onMouseEnter() {
    this.iconColor = '#495057';
  }

  onMouseLeave() {
    this.iconColor = '#868b8fff';
  }

  @Input() target!: string;
  @Input() iconClass: string = 'bi bi-question-circle ms-2';


  constructor(private el: ElementRef) { }

  ngAfterViewInit(): void {
    // Inicializa el tooltip de Bootstrap sobre el icono
    const icon: HTMLElement | null = this.el.nativeElement.querySelector('i[data-bs-toggle="tooltip"]');
    if (icon && window['bootstrap']) {
      if (this.tooltipInstance) {
        this.tooltipInstance.dispose();
      }
      this.tooltipInstance = new window['bootstrap'].Tooltip(icon, {
        customClass: 'field-info-custom-tooltip'
      });
    }
  }

  ngOnDestroy(): void {
    if (this.tooltipInstance) {
      this.tooltipInstance.dispose();
      this.tooltipInstance = null;
    }
  }

  ngOnInit(): void {

  }

  getTooltipHtml(): string {
    switch (this.target) {
      case 'analytic-inactive-legends':
        return `<div style="font-size: 12px;"><div style="white-space: nowrap;"><strong>Inactive</strong></div>
        <div style="white-space: nowrap;"><strong>IR:</strong> Inactive Request</div>
        <div style="white-space: nowrap;"><strong>M:</strong> Modification</div>
        <div style="white-space: nowrap;"><strong>CU:</strong> Canceled Upgrade</div>
        <div style="white-space: nowrap;"><strong>B:</strong> Deactivated Button</div>`;
      default:
        return `<div style="font-size: 12px;"><div style="white-space: nowrap;"><strong>Default:</strong> default</div>`;

    }

  }
}
